export const GET_VIDEO_CALL_SETUP = "GET_VIDEO_CALL_SETUP"
export const GET_VIDEO_CALL_SETUP_SUCCESS = "GET_VIDEO_CALL_SETUP_SUCCESS"
export const GET_VIDEO_CALL_SETUP_FAILED = "GET_VIDEO_CALL_SETUP_FAILED"
export const RESET_VIDEO_CALL_SETUP = "RESET_VIDEO_CALL_SETUP"

export const UPDATE_VIDEO_CALL_SETUP = "UPDATE_VIDEO_CALL_SETUP"
export const UPDATE_VIDEO_CALL_SETUP_SUCCESS = "UPDATE_VIDEO_CALL_SETUP_SUCCESS"
export const UPDATE_VIDEO_CALL_SETUP_FAILED = "UPDATE_VIDEO_CALL_SETUP_FAILED"
